import type { JSX } from "react";

import type { SourcingTab } from "../routes";
import { CriteriaCatalogPage } from "./criteria_catalog/Page";
import { CriteriaCompletionPage } from "./criteria_completion_phase/Page";
import { CriteriaRankingPage } from "./criteria_ranking/Page";
import { DropPerPhasePage } from "./drop_per_phase/Page";
import { FeaturePerformanceAveragePage, FeaturePerformanceMinimumPage } from "./feature_performance/Page";
import { FeatureRankingPage } from "./feature_ranking/Page";
import { FunnelReasonPage } from "./funnel_name_vs_reason/Page";
import { GeoSegmentationPage } from "./geo_segmentation/Page";
import { GeoGroupsPage } from "./geo_segmentation_groups/Page";
import { IngredientsFunnelPage } from "./ingredients_funnel/Page";
import { ItemOverviewPage } from "./item_overview/Page";
import { LandedByOfferPage } from "./landed_cost_by_offer/Page";
import { LandedVsPurchasePage } from "./landed_cost_vs_purchase/Page";
import { MonthlyOffersPage } from "./monthly_offers_purchases/Page";
import { MarginAtStakePage } from "./margin_at_stake/Page";
import { MarginItemsPage } from "./margin_items/Page";
import { OptionOverviewPage } from "./option_overview/Page";
import { RankingTablePage } from "./ranking_table/Page";
import { SourcingFunnelPage } from "./sourcing_funnel/Page";
import { SpeedMonthPage, SpeedWeekPage } from "./speed_options/Page";
import { StalledPage } from "./stalled/Page";
import { TplCostModelPage } from "./tpl_cost_model/Page";
import { ViewHealthPage } from "./view_health/Page";

export interface PageProps {
  tab: SourcingTab;
  areaName: string;
}

export const PAGES: Partial<Record<string, (props: PageProps) => JSX.Element>> = {
  margin_at_stake: MarginAtStakePage,
  margin_items: MarginItemsPage,
  stalled: StalledPage,
  ranking_table: RankingTablePage,
  feature_ranking: FeatureRankingPage,
  criteria_ranking: CriteriaRankingPage,
  criteria_catalog: CriteriaCatalogPage,
  view_health: ViewHealthPage,
  feature_performance_average: FeaturePerformanceAveragePage,
  feature_performance_minimum: FeaturePerformanceMinimumPage,
  criteria_completion_phase: CriteriaCompletionPage,
  funnel_name_vs_reason: FunnelReasonPage,
  geo_segmentation: GeoSegmentationPage,
  geo_segmentation_groups: GeoGroupsPage,
  landed_cost_by_offer: LandedByOfferPage,
  sourcing_funnel: SourcingFunnelPage,
  ingredients_funnel: IngredientsFunnelPage,
  landed_cost_vs_purchase: LandedVsPurchasePage,
  monthly_offers_purchases: MonthlyOffersPage,
  speed_options_month: SpeedMonthPage,
  speed_options_week: SpeedWeekPage,
  drop_per_phase: DropPerPhasePage,
  item_overview: ItemOverviewPage,
  option_overview: OptionOverviewPage,
  tpl_cost_model: TplCostModelPage,
};
